import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import vuetify from "./plugins/vuetify";
import "@plugins/config";
import "@plugins/utils";

import "@/plugins/vue-uuid";
import "@/plugins/page-transitions";
import PsiComponentLib from "@ronfuller/psi-component-lib";
import Permissions from "@/mixins/permissions";

Vue.use(PsiComponentLib);

// Import Global Access to Trix, Trouble with this package forced a component outside the Psi Component Lib
import PsiFormTrixField from "@components/lib/PsiFormTrixField";
Vue.component("PsiFormTrixField", PsiFormTrixField);
Vue.mixin(Permissions);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount("#app");
